import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminNotifications = lazy(() => import("@/pages/admin/AdminNotifications"));

export const Route = createFileRoute("/admin/notifications")({
  component: AdminNotifications,
});
